module.exports = __webpack_public_path__ + "img/st.43f8786b.svg";